import { Popover } from 'antd';
import React, { useState } from 'react';
import RepeatOptions from './RepeatOptions';
import Text from 'components/Text';
import shopSelectors from 'services/selectors/shop';
import { loadingSignal } from 'components/Loading';
import aptSignal from './signal';
import { ANYONE_ID } from 'Calendar/anyone';
import { AppointmentStatus } from 'Turn/services/constants';

/**
 * Nut Repeat trong footer man Detail Appointment.
 *
 * An hoan toan khi tiem chua bat cau hinh, hoac khi lich chua duoc confirm. Bi khoa khi
 * lich da thuoc mot chuoi (tranh chuoi chong chuoi) hoac chua chon tho — server chan ca
 * hai truong hop, day chi la lop UX phia truoc.
 */
const RepeatButton = ({ onRepeat }: { onRepeat: (dayRepeat: number) => void }) => {
  const enableAppointmentRepeat = shopSelectors.setting().enableAppointmentRepeat;
  const [open, setOpen] = useState(false);

  if (!enableAppointmentRepeat) return null;

  // Chi lich da confirm moi duoc nhan ban. Lich con o trang thai NEW van co the bi doi gio
  // hoac huy, nhan ban som se sinh ra ca chuoi phai sua lai tung buoi.
  if (aptSignal.detailStatusSignal.value !== AppointmentStatus.CONFIRMED) return null;

  // Bam theo trang thai request that su, khong hen gio: tao 12 lich cong voi lan refresh
  // sau do thuong lau hon bat ky moc thoi gian doan truoc nao. Overlay loading co z-index
  // thap hon footer nen khong che duoc nut — day moi la thu chan bam lan hai.
  const submitting = loadingSignal.value;

  const alreadyInSeries = !!aptSignal.detailSeriesIdSignal.value;
  // ANYONE_ID la chuoi '0' — truthy. Chi kiem tra !staffId se bo lot dung truong hop can
  // chan, vi mapper doi staffId 0 thanh ANYONE_ID (services/helpers.ts).
  const staffId = aptSignal.staffIdSignal.value;
  const noStaff = !staffId || staffId === ANYONE_ID;
  const disabled = alreadyInSeries || noStaff || submitting;

  const title = alreadyInSeries
    ? 'This appointment is already repeating'
    : noStaff
      ? 'Assign a staff before repeating'
      : 'Repeat this appointment';

  const handlePick = (dayRepeat: number) => {
    setOpen(false);
    onRepeat(dayRepeat);
  };

  return (
    <Popover
      open={open && !disabled}
      onOpenChange={(next) => setOpen(next && !disabled)}
      trigger='click'
      placement='top'
      // Cac dong tu ve duong ke rieng, nen bo padding mac dinh cua antd de chung chay het
      // be ngang popover — vung bam rong hon dung bang chieu rong that su.
      overlayInnerStyle={{ padding: '8px 0' }}
      content={<RepeatOptions startTime={aptSignal.timeSignal.value} onPick={handlePick} />}
    >
      <button
        type='button'
        className='btn btn-close'
        disabled={disabled}
        title={title}
        style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
      >
        <Text className="label">REPEAT</Text>
      </button>
    </Popover>
  );
};

export default RepeatButton;
